import { useQuery } from 'react-query';
import {
  getFanLetterById,
  type GetFanLetterByIdResponse
} from '../../services/bettieFanLettersService';

export function useGetFanLetterById({ letterId }: { letterId: string }) {
  return useQuery<GetFanLetterByIdResponse>(['fanLetter', letterId], () =>
    getFanLetterById({ id: letterId })
  );
}
